import React from "react";
import { FileTextIcon, LayersIcon, LayoutGridIcon, RulerIcon, ScanIcon, SearchIcon } from "lucide-react";
import { tools } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
const iconMap = {
  file: FileTextIcon,
  layers: LayersIcon,
  scan: ScanIcon,
  grid: LayoutGridIcon,
  ruler: RulerIcon,
  search: SearchIcon
} as const;
export function Tools() {
  return <section className="bg-navy px-4 py-16 md:py-24" data-id="element-286" data-mp="28jv644jpex0x">
      <div className="mx-auto max-w-5xl" data-id="element-287" data-mp="28ko6mns2kqam">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-white md:text-5xl" data-id="element-288" data-mp="23s4r3l9tnl36">
          Plus, you'll get <em className="italic text-gold" data-id="element-289" data-mp="1yublatcfkt3f">immediate access</em> to:
        </h2>

        <ul className="mt-10 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-290" data-mp="1tv8g98wgamvg">
          {tools.map(t => {
          const Icon = iconMap[t.icon as keyof typeof iconMap];
          return <li key={t.title} className="flex gap-4" data-id="element-291" data-mp="1kt8z8glfrisi">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand" data-id="element-292" data-mp="1kvvel2ekj2la">
                  <Icon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-293" data-mp="157mxw364mb82" />
                </span>
                <div data-id="element-294" data-mp="1a20xyivqh6j2">
                  <h3 className="text-lg font-bold leading-snug text-white" data-id="element-295" data-mp="w91jmk7otid3">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/75" data-id="element-296" data-mp="10ad1g3kbkzaq">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl rounded-3xl bg-navy-800 p-6 text-center ring-1 ring-white/10 md:p-8" data-id="element-297" data-mp="1o0qrjojcgo2o">
          <p className="font-serif text-2xl font-extrabold text-white" data-id="element-298" data-mp="1swoam2lzs8j5">Any implant case that enters your practice…</p>
          <p className="mt-3 text-[17px] leading-relaxed text-white/80" data-id="element-299" data-mp="1jy3yjkaxsx3w">
            You won't have to start from a blank page. You'll have a structured workflow to evaluate the case, organize the information, identify the major decisions and prepare your plan.
          </p>
        </div>

        <SectionCTA label="Get Full Access to the Playbook™" dark data-id="element-300" data-mp="2a8d00nm8ilqg" />
      </div>
    </section>;
}